import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Container } from '@ucheba/ui/components/Container/desktop'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { AGREEMENTS_LINKS } from '@ucheba/utils/constants/core'
import RequestForm from '../../../RequestForm/desktop'
import { EApplicationFunnels } from '../../../AppliactionForm/types'
import { ISchoolFormProps } from '../types'

const Block = styled.div`
  background-color: ${sv.color.plum};
  color: white;
  position: relative;
`

const Image = styled.img`
  max-width: 354px;
`

const ImageBg = styled.img`
  position: absolute;
  width: 668px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`

const Inner = styled.div`
  position: relative;
  padding: 80px 0 80px 0;
`

const SchoolForm: FC<ISchoolFormProps> = (props) => {
  const {
    title,
    img,
    bgImg,
    personalDate,
    children,
    requestTarget,
    productType,
    elements,
    buttonColor = 'gold',
    totalDiscount,
    funnel = EApplicationFunnels.course_booking,
    productId,
  } = props

  const titleStatic = `<span style="font-weight: 800;">Приходите знакомиться с&nbsp;нами на&nbsp;бесплатный
                        вводный урок</span> и&nbsp;забронируйте скидку до&nbsp;${totalDiscount}% на&nbsp;обучение`

  return (
    <Block>
      <Container>
        <Inner>
          <Grid justifyContent='space-between'>
            <GridCol uxs={9}>
              <div
                style={{
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                <Text fontSize='h2' lineHeight='h2'>
                  {title || titleStatic}
                </Text>

                <Spacing spacing='medium' />

                <Image src={img} />
              </div>
            </GridCol>

            <GridCol uxs={8}>
              <RequestForm
                title='Оставьте заявку'
                description='Мы перезвоним вам с 9:00 до 21:00 без выходных'
                buttonColor={buttonColor}
                funnel={funnel}
                productType={productType}
                requestTarget={requestTarget}
                productId={productId}
              />

              <Spacing spacing='small' />

              <div
                style={{
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {personalDate ? (
                  <Text fontSize='xsmall1' lineHeight='xsmall1' textAlign='center'>
                    {`<span style="opacity: 0.5">${personalDate}</span>`}
                  </Text>
                ) : (
                  <Text
                    fontSize='xsmall1'
                    lineHeight='xsmall1'
                    textAlign='center'
                    html={false}
                  >
                    <span style={{ opacity: '0.5' }}>
                      Продолжая, вы соглашаетесь на обработку персональных данных на
                      условиях{' '}
                      <a
                        target='_blank'
                        rel='noreferrer'
                        href={`${AGREEMENTS_LINKS.personalData}`}
                        style={{
                          color: 'inherit',
                          textDecoration: 'underline',
                        }}
                      >
                        Согласия на обработку персональных данных
                      </a>{' '}
                      и принимаете условия{' '}
                      <a
                        target='_blank'
                        rel='noreferrer'
                        href={`${AGREEMENTS_LINKS.agreementsForMain}`}
                        style={{
                          color: 'inherit',
                          textDecoration: 'underline',
                        }}
                      >
                        Пользовательского соглашения.
                      </a>
                    </span>
                  </Text>
                )}
              </div>
            </GridCol>
          </Grid>

          <div
            style={{
              position: 'absolute',
              bottom: '16px',
              right: 0,
              zIndex: 1,
            }}
          >
            {elements}
          </div>
        </Inner>
      </Container>

      <ImageBg src={bgImg} />

      {children}
    </Block>
  )
}

export default memo(SchoolForm)
